import React from 'react';
import { observer } from 'mobx-react';
import { NotFoundTemplate } from 'themes/common/pages';
import { useStores } from 'core/stores/StoreContext';

const NotFound = observer((props) => {
    const rootStore = useStores();
    return <NotFoundTemplate {...props} rootStore={rootStore} />;
});

export default NotFound;
